import { render, staticRenderFns } from "./EachDomain.vue?vue&type=template&id=63c35765&scoped=true&"
import script from "./EachDomain.vue?vue&type=script&lang=js&"
export * from "./EachDomain.vue?vue&type=script&lang=js&"
import style0 from "./EachDomain.vue?vue&type=style&index=0&id=63c35765&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c35765",
  null
  
)

export default component.exports